// const config = {host:"https://server:8080",timer:2}
const config = {host:"http://localhost:8080/api",timer:2}
export default config